import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { API, Endpoints, Tag } from "@brg/api";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";

import { bTag, LayoutConst } from "../../../core";
import { CloseIcon } from "../../../shared/icons";
import { BTag } from "../../../core/components";
import useQueryState from "../../../shared/hooks/useQueryState";
import styled from "styled-components";
import { CollapseButton } from "shared/components/CollapseButton/CollapseButton";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useDeepCompareEffect} from "../../../shared/utils/useDeepCompareEffect";
import { ScrollWrapper, TagsTitleWrapper, TagWrapper } from "shared/pages/designer/components/DesignerFolders/components/designerTagsCloud";
import useCompetitionTagList from "shared/hooks/useCompetitionTagList";

interface DesignerTagsCloudProps {
  filter: any;
}

const CompetitionsTagWrapper = styled(TagWrapper)<{ isGeo?: boolean, themeType?: string }>`
  background-color: ${({ isGeo, themeType }) => themeType === 'black' ? '#1f1f1f': themeType === 'grey' ? '#353A3E' : '#464645'};
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
    margin-top: 16px;
    height: ${({isLoading}) => isLoading ? '78px' : 'auto'};
  }
`

const CompetitionsScrollWrapper = styled(ScrollWrapper)<{ collapse?: boolean, isGeo?: boolean }>`

  &:after {
    background: ${({ isGeo }) => isGeo ? '#353A3E' : '#464645'};
    display: none;
  }
  max-height: ${({ collapse }) => collapse ? '88px' : 'none'};
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    max-height: ${({ collapse }) => collapse ? '85px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: ${({ collapse }) => collapse ? '80px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-height: ${({ collapse }) => collapse ? '80px' : 'none'};
  }
`

export const CompetitionTagsCloud: FC<DesignerTagsCloudProps> = ({ filter }) => {

  const [isEditMode, setIsEditMode] = useState(false);
  const tagsRef = useRef<HTMLDivElement>(null);
  const [{ tab, tagId: queryTag, sorting }, setQueryState] = useQueryState();
  const [open, setOpen] = useState(false);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const [collapseVisible, setCollapseVisible] = useState(false);

  const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();

  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])

  const maxTagHeight = (isMac13 || smHeight) ? 88 : 92;

  const onTagClick = useCallback((tagId: string, isHidden?: boolean) => {
    console.log('tab', tab);
    
    setQueryState({ tagId: queryTag === tagId ? undefined : tagId, sorting }, { replace: true })
  }, [queryTag, tab, sorting])

  const localFilter = useMemo(() => {
    return {
      competitionStatus: filter?.competitionStatus,
      contexts: filter?.contexts,
      isBriefCompetition: !!filter?.isBriefCompetition,
      initWinner: filter?.initWinner,
      initTags: filter?.initTags,
    }
  }, [filter])

  const { tags, loading } = useCompetitionTagList({ filter: localFilter });

  useEffect(() => {
    setTimeout(() => {
      const tagsContainer = document.querySelector('#tags-scroll-container');
      setCollapseVisible(false);

      if (tagsContainer) {
        if (tagsContainer.scrollHeight > maxTagHeight) {
          setCollapseVisible(true)
        }
      }
    } , 100)
       
  },[loading, tags, maxTagHeight]);

  const collapseButton = useMemo(() => {
    if (!collapseVisible) return null;

    return <CollapseButton onClick={() => setOpen(!open)} flag={open} />
  } , [open, collapseVisible])

  if (loading && !tags?.length) return <TagWrapper isLoading isCompetition isGeo={isGeo}/>

  if (!tags?.length) return null;

  return <CompetitionsTagWrapper isGeo={isGeo} themeType={isGeo ? 'grey' : isCGRAVE || isAdcrDafesNet ? 'black' : 'white'}>
    <FlexBox direction="column">
      <FlexBox direction="column" directionMobile="column" gy={12} width='100%'>
        <CompetitionsScrollWrapper id={'tags-scroll-container'} ref={tagsRef} collapse={!open} isGeo={isGeo}>
          <BTagsGridNew noLimitMaxHeight>
            {tags?.map((tag: Tag) => <BTag
                tag={tag}
                onClick={() => onTagClick(tag.tagId)}
                key={tag.tagId}
                selected={tag.tagId === queryTag}
                educational={tag?.isEducationTag}
                organization={tag?.isTeamTag}
                isDeziiignStyle
                isTagsCloud
            >
              <TagsTitleWrapper gx={8}><span>{bTag.title(tag)}</span> {isEditMode && <CloseIcon/>}</TagsTitleWrapper>
            </BTag>)}
          </BTagsGridNew>
        </CompetitionsScrollWrapper>
      </FlexBox>
    </FlexBox>
    {collapseButton}
  </CompetitionsTagWrapper>;
}import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { API, Endpoints, Tag } from "@brg/api";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";

import { bTag, LayoutConst } from "../../../core";
import { CloseIcon } from "../../../shared/icons";
import { BTag } from "../../../core/components";
import useQueryState from "../../../shared/hooks/useQueryState";
import styled from "styled-components";
import { CollapseButton } from "shared/components/CollapseButton/CollapseButton";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useDeepCompareEffect} from "../../../shared/utils/useDeepCompareEffect";
import { ScrollWrapper, TagsTitleWrapper, TagWrapper } from "shared/pages/designer/components/DesignerFolders/components/designerTagsCloud";
import useCompetitionTagList from "shared/hooks/useCompetitionTagList";

interface DesignerTagsCloudProps {
  filter: any;
}

const CompetitionsTagWrapper = styled(TagWrapper)<{ isGeo?: boolean, themeType?: string }>`
  background-color: ${({ isGeo, themeType }) => themeType === 'black' ? '#1f1f1f': themeType === 'grey' ? '#353A3E' : '#464645'};
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
    margin-top: 16px;
    height: ${({isLoading}) => isLoading ? '78px' : 'auto'};
  }
`

const CompetitionsScrollWrapper = styled(ScrollWrapper)<{ collapse?: boolean, isGeo?: boolean }>`

  &:after {
    background: ${({ isGeo }) => isGeo ? '#353A3E' : '#464645'};
    display: none;
  }
  max-height: ${({ collapse }) => collapse ? '88px' : 'none'};
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    max-height: ${({ collapse }) => collapse ? '85px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: ${({ collapse }) => collapse ? '80px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-height: ${({ collapse }) => collapse ? '80px' : 'none'};
  }
`

export const CompetitionTagsCloud: FC<DesignerTagsCloudProps> = ({ filter }) => {

  const [isEditMode, setIsEditMode] = useState(false);
  const tagsRef = useRef<HTMLDivElement>(null);
  const [{ tab, tagId: queryTag, sorting }, setQueryState] = useQueryState();
  const [open, setOpen] = useState(false);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const [collapseVisible, setCollapseVisible] = useState(false);

  const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();

  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])

  const maxTagHeight = (isMac13 || smHeight) ? 88 : 92;

  const onTagClick = useCallback((tagId: string, isHidden?: boolean) => {
    console.log('tab', tab);
    
    setQueryState({ tagId: queryTag === tagId ? undefined : tagId, sorting }, { replace: true })
  }, [queryTag, tab, sorting])

  const localFilter = useMemo(() => {
    return {
      competitionStatus: filter?.competitionStatus,
      contexts: filter?.contexts,
      isBriefCompetition: !!filter?.isBriefCompetition,
      initWinner: filter?.initWinner,
      initTags: filter?.initTags,
    }
  }, [filter])

  const { tags, loading } = useCompetitionTagList({ filter: localFilter });

  useEffect(() => {
    setTimeout(() => {
      const tagsContainer = document.querySelector('#tags-scroll-container');
      setCollapseVisible(false);

      if (tagsContainer) {
        if (tagsContainer.scrollHeight > maxTagHeight) {
          setCollapseVisible(true)
        }
      }
    } , 100)
       
  },[loading, tags, maxTagHeight]);

  const collapseButton = useMemo(() => {
    if (!collapseVisible) return null;

    return <CollapseButton onClick={() => setOpen(!open)} flag={open} />
  } , [open, collapseVisible])

  if (loading && !tags?.length) return <TagWrapper isLoading isCompetition isGeo={isGeo}/>

  if (!tags?.length) return null;

  return <CompetitionsTagWrapper isGeo={isGeo} themeType={isGeo ? 'grey' : isCGRAVE || isAdcrDafesNet ? 'black' : 'white'}>
    <FlexBox direction="column">
      <FlexBox direction="column" directionMobile="column" gy={12} width='100%'>
        <CompetitionsScrollWrapper id={'tags-scroll-container'} ref={tagsRef} collapse={!open} isGeo={isGeo}>
          <BTagsGridNew noLimitMaxHeight>
            {tags?.map((tag: Tag) => <BTag
                tag={tag}
                onClick={() => onTagClick(tag.tagId)}
                key={tag.tagId}
                selected={tag.tagId === queryTag}
                educational={tag?.isEducationTag}
                organization={tag?.isTeamTag}
                isDeziiignStyle
                isTagsCloud
            >
              <TagsTitleWrapper gx={8}><span>{bTag.title(tag)}</span> {isEditMode && <CloseIcon/>}</TagsTitleWrapper>
            </BTag>)}
          </BTagsGridNew>
        </CompetitionsScrollWrapper>
      </FlexBox>
    </FlexBox>
    {collapseButton}
  </CompetitionsTagWrapper>;
}